import { Link } from "react-router-dom";
import { Bell, AlertTriangle, Info, Sparkle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useList } from "@/hooks/useData";

const ICON = { alerte: AlertTriangle, info: Info, nouveau: Sparkle };

export const NotificationList = ({ items, compact }) => (
  <ul className="divide-y divide-slate-100" data-testid="notifications-list">
    {!items.length && <li className="py-6 text-center text-xs text-slate-400">Aucune notification</li>}
    {items.slice(0, compact ? 8 : 50).map((n) => {
      const I = ICON[n.niveau] || Info;
      return (
        <li key={n.id}>
          <Link to={n.lien} className="flex gap-3 py-2.5 hover:bg-slate-50" data-testid={`notification-${n.id}`}>
            <I className={`mt-0.5 h-4 w-4 shrink-0 ${n.niveau === "alerte" || n.niveau === "nouveau" ? "text-[#D82C2C]" : "text-[#0F2840]"}`} />
            <span>
              <span className="block text-xs font-bold">{n.titre}</span>
              <span className="block text-xs text-slate-500">{n.message}</span>
            </span>
          </Link>
        </li>
      );
    })}
  </ul>
);

export const NotificationsBell = () => {
  const { data = [] } = useList("/admin/notifications");
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative grid h-10 w-10 place-items-center rounded-md hover:bg-slate-100" data-testid="notifications-bell" aria-label="Notifications">
          <Bell className="h-5 w-5" />
          {data.length > 0 && <span className="absolute right-1.5 top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-[#D82C2C] px-1 text-[10px] font-bold text-white" data-testid="notifications-count">{data.length}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-3">
        <p className="mb-1 text-xs font-bold uppercase tracking-wider text-slate-500">Notifications & rappels</p>
        <NotificationList items={data} compact />
      </PopoverContent>
    </Popover>
  );
};
